module.exports = __webpack_public_path__ + "static/img/no-audio.29a52e9a.svg";